import { api } from './BaseService'

export const getProducts = async (data) => {
    return await api.get(`/products`,{params:data})
}
export const getProductReport = async (data) => {
    return await api.post(`/products_report`,data)
}

export const getProductsBySearch = async (data) => {
    return await api.get(`/products/autocomplete`, {params:data})
}

export const getFabricBySearch = async (data) => {
    return await api.get(`/fabrics/autocomplete`, {params:data})
}

export const getProductById = async (id) => {
    return await api.get(`/products/${id}`)
}

export const createProduct = async (data) => {
    return await api.post(`/products`, data)
}
export const updateProduct = async (data) => {
    return await api.put(`/products/${data?.get('id')}`, data)
}
export const deleteProduct = async (id) => {
    return await api.delete(`/products/${id}`)
}
